import { BitkitAvatar, BitkitIconComponent, IconApple, IconLinux, IconOther } from '@bitrise/bitkit-v2';
import { forwardRef } from 'react';

import { NormalizedOS } from '@/types/StackAndMachine';

type MachineTypeAvatarProps = {
  type: NormalizedOS;
};

const iconMap: Record<MachineTypeAvatarProps['type'], BitkitIconComponent> = {
  linux: IconLinux,
  macos: IconApple,
  unknown: IconOther,
};

export const machineTypeIcon = (type: NormalizedOS = 'unknown'): BitkitIconComponent => iconMap[type];

const MachineTypeAvatar = forwardRef<HTMLDivElement, MachineTypeAvatarProps>((props, ref) => {
  const { type = 'unknown', ...rest } = props;
  return <BitkitAvatar variant="icon" size="24" icon={iconMap[type]} {...rest} ref={ref} />;
});

MachineTypeAvatar.displayName = 'MachineTypeAvatar';

export default MachineTypeAvatar;
